import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuarterPickerComponent } from '../quarter-picker/quarter-picker.component';
import { EventsHubService } from '../../../core/events-hub.service';
import { RmsUtilsService } from '../../../core/services';

@Component({
    selector: 'rms-year-portion-picker',
    templateUrl: './year-portion-picker.component.html',
    styleUrls: ['./year-portion-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YearPortionPickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class YearPortionPickerComponent extends QuarterPickerComponent implements OnInit {

  constructor(
    eventsHubService: EventsHubService,
    utilsService: RmsUtilsService,
    cd: ChangeDetectorRef
  ) {
    super(eventsHubService, utilsService, cd);
  }

  ngOnInit() {
  }

}
